
import './common.js';

import './libs/menu-complex.js';

import '../scss/complex_construction.scss';

import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, EffectFade]);

/* слайдер image */
let imageSlider = new Swiper(".construction-content__imageslider .swiper-container", {
    effect: 'fade',
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    allowTouchMove: true,
    breakpoints: {
        1171: {
            allowTouchMove: false,
        }
    },
    pagination: {
        el: ".construction-content__imageslider-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".construction-content__imageslider-next",
        prevEl: ".construction-content__imageslider-prev",
    },

});
/* слайдер image */

function reInitImageSlider() {
    let yearActive = parseInt(document.querySelector('.construction-content__year.active').getAttribute('data-year'));
    let mounthActive = document.querySelector('.construction-content__mounth.active').getAttribute('data-mounth');
    let tmp = window.complexContentSliderData.find(item => item.year === yearActive && item.mounth === mounthActive );
    if(tmp && tmp != undefined) {
        let images = tmp.images;
        let html = "";
        images.forEach((image) => {
            html += '<div class="swiper-slide"><div class="construction-content__imageslider-item" data-img-src="'+image+'"><picture><source media="(max-width: 767px)"  srcset="'+image+'"><img loading="lazy"  src="'+image+'"></picture></div></div>'
        });
        document.querySelector('.construction-content__imageslider .swiper-wrapper').innerHTML = html;

        imageSlider = new Swiper(".construction-content__imageslider .swiper-container", {
            effect: 'fade',
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            pagination: {
                el: ".construction-content__imageslider-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".construction-content__imageslider-next",
                prevEl: ".construction-content__imageslider-prev",
            },

        });
        if(document.querySelector('.construction-content__imageslider [data-img-src]')) {
            document.querySelectorAll('.construction-content__imageslider [data-img-src]').forEach((el) => {
                el.addEventListener('click', function  popupOpen(event) {
                    event.preventDefault();
                    let src = event.currentTarget.getAttribute('data-img-src');
                    if(document.querySelector('#imagePopup .popup__img')) {
                        document.querySelector('#imagePopup .popup__img').setAttribute('src', src);

                        setTimeout(() => {
                            document.querySelector('#imagePopup').style.display="flex";
                            document.body.classList.add('oc-hidden');
                        }, 200);
                    }
                })
            })
        }
    }
}

/* таб year */
//slider
let yearSlider = new Swiper(".construction-content__menuyear", {
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: false,
    slideToClickedSlide: true,
    allowTouchMove: true,
    breakpoints: {
        1171: {
            allowTouchMove: false,
        }
    },
});
if(document.body.clientWidth <= 950) {
    let index = 0;
    document.querySelectorAll('.construction-content__menuyear .construction-content__year').forEach((item) => {
        if (!item.classList.contains('active')) {
            index = index + 1;
        }
        else {
            yearSlider.slideTo(index)
        }
    });
}
//переключение
document.querySelectorAll('.construction-content__year').forEach((item) => {
    item.addEventListener('click', (e) => {
        document.querySelectorAll('.construction-content__year').forEach((el) => {
            el.classList.remove('active')
        });

        e.currentTarget.classList.add('active');
        let yearActive = parseInt(document.querySelector('.construction-content__year.active').getAttribute('data-year'));
        // document.querySelectorAll('.construction-content__mounth').forEach((el) => {
        //     el.classList.add('disable')
        //     el.classList.remove('active')
        // });

        document.querySelector('.construction-content__menumounth .swiper-wrapper').innerHTML = '';
        window.complexContentSliderData.forEach((el) => {
            if(el.year === yearActive) {
                // document.querySelector('.construction-content__mounth[data-mounth="'+el.mounth+'"]').classList.remove('disable')
                document.querySelector('.construction-content__menumounth .swiper-wrapper').innerHTML += '<div class="swiper-slide"><div data-mounth="'+el.mounth+'" class="construction-content__mounth">'+el.mounth+'</div></div>';
            }
        });
        reInitMounthSlider();
        // if(document.querySelector('.construction-content__mounth:not(.disable)')) {
        document.querySelector('.construction-content__mounth:not(.disable)').classList.add('active')
        // }
        reInitImageSlider();
    });
});
/* таб year */

/* таб mouth */
//slider
let mouthSlider = null;
function reInitMounthSlider() {
    if(document.querySelector('.construction-content__menumounth.swiper-initialized')) {
        mouthSlider.destroy( true, true);
    }
    mouthSlider = new Swiper(".construction-content__menumounth", {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        allowTouchMove: true,
        breakpoints: {
            1180: {
                allowTouchMove: false,
            }
        },
    });
    if(document.body.clientWidth <= 1170) {
        let width = 0;
        document.querySelectorAll('.construction-content__menumounth .construction-content__mounth').forEach((item) => {
            if (!item.classList.contains('active')) {
                width = width + item.offsetWidth + 10;
            }
            else {
                width = width - document.body.clientWidth / 2 + item.offsetWidth / 2 + 10;
                if(width > 0) {
                    mouthSlider.setTranslate(-width);
                }
            }
        });
    }
    //переключение
    document.querySelectorAll('.construction-content__mounth').forEach((item) => {
        item.addEventListener('click', (e) => {
            document.querySelectorAll('.construction-content__mounth').forEach((el) => {
                el.classList.remove('active')
            });

            e.currentTarget.classList.add('active');
            reInitImageSlider();
        });
    });
}
reInitMounthSlider();
/* таб mouth */